import { CHART_PRESET } from '../Charts/chart-presets';

export const SERIES_PALETTE = CHART_PRESET.seriesPalette;
export const OVERLAY_PALETTE = CHART_PRESET.overlayPalette;
export const CHART_MARGIN = CHART_PRESET.margin;
export const NUMERIC_X_CHART_MARGIN = CHART_PRESET.numericXMargin;
export const AXIS_TICK_FONT_SIZE = CHART_PRESET.axisTickFontSize;
export const MAX_BAR_SIZE = CHART_PRESET.barMaxWidth;

// Font size for axis titles (the metric/segment name along an axis) — matches the tick labels.
export const AXIS_TITLE_FONT_SIZE = CHART_PRESET.axisTickFontSize;

// Extra room an axis needs for its title: the title's line (~12px) and a 4px gap from the tick
// labels, plus the 8px recharts always keeps between the axis line and its tick labels (tickSize 6 +
// tickMargin 2, reserved even with tickLine off). The measured axis width covers only the tick text,
// so without those 8px the widest tick label runs into the title.
export const AXIS_TITLE_GUTTER = 24;

// Font size for the series legend — smaller than recharts' ~14px default so it reads compact.
export const LEGEND_FONT_SIZE = 11;
